import { SEOHead } from '../../components/seo/SEOHead';
import { useOrders } from '../../hooks/useOrders';
import { Spinner } from '../../components/ui/Card';
import { Link } from 'react-router-dom';

export default function DocumentUploads() {
  const { orders, isLoading } = useOrders();
  const ordersNeedingDocs = orders.filter((o) =>
    ['documents_requested', 'documents_received', 'assigned'].includes(o.status)
  );

  return (
    <>
      <SEOHead title="Documents — Bharat Consultancy" description="" canonicalPath="/dashboard/documents" />

      <h1 className="font-display text-2xl font-bold text-ink">Document Uploads</h1>
      <p className="mt-1 text-ink/60">Upload requested documents for orders that need them.</p>

      <div className="mt-6 space-y-3">
        {isLoading ? (
          <Spinner className="h-6 w-6 text-seal-blue" />
        ) : ordersNeedingDocs.length === 0 ? (
          <p className="text-ink/60">No orders currently need document uploads.</p>
        ) : (
          ordersNeedingDocs.map((order) => (
            <Link
              key={order.id}
              to={`/dashboard/orders/${order.id}`}
              className="block rounded-lg border border-line bg-white p-4 hover:shadow-stamp"
            >
              <p className="font-mono text-sm text-ink/50">{order.orderNumber}</p>
              <p className="font-medium text-ink">{order.service?.title ?? 'Service'}</p>
              <p className="mt-1 text-sm text-seal-blue">Upload documents →</p>
            </Link>
          ))
        )}
      </div>
    </>
  );
}
